import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { MtnaDataType } from '@mtna/data-core-ui';

import { RdsDataTypeUtil } from '../utils/data-type-util';

@Pipe({
  name: 'rdsIsDataTypeText',
})
export class RdsIsDataTypeTextPipe implements PipeTransform {
  transform(value: MtnaDataType): boolean {
    return RdsDataTypeUtil.isMtnaDataTypeText(value);
  }
}

@NgModule({
  declarations: [RdsIsDataTypeTextPipe],
  exports: [RdsIsDataTypeTextPipe],
})
export class RdsIsDataTypeTextPipeModule {}
